var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_726588440"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M168 0l-43 0 -47 0 -43 0 -35 57 0 146 78 0 47 0 78 0 0 -146 -35 -57zm-4 7l30 47 -69 0 0 -47 39 0zm-62 0l17 0 0 47 -17 0 -17 0 0 -47 17 0zm-17 54l3 0c0,2 2,3 3,3 2,0 4,-1 4,-3l13 0c0,2 2,3 4,3 2,0 3,-1 3,-3l4 0 0 12 -4 -3 -13 13 -14 -13 -3 3 0 -12zm-46 -54l39 0 0 47 -69 0 30 -47zm46 189l0 -8 3 3 14 -13 13 13 4 -3 0 8 -34 0zm40 0l0 -25 -10 10 -13 -13 -14 13 -10 -10 0 25 -71 0 0 -135 71 0 0 28 10 -10 14 14 13 -14 10 10 0 -28 71 0 0 135 -71 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M68 163l67 0 0 -61 -67 0 0 61zm7 -55l54 0 0 48 -54 0 0 -48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M105 142l-20 0c-2,0 -4,2 -4,4 0,1 2,3 4,3l20 0c2,0 3,-2 3,-3 0,-2 -1,-4 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M119 142l-4 0c-2,0 -3,2 -3,4 0,1 1,3 3,3l4 0c1,0 3,-2 3,-3 0,-2 -2,-4 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M119 115l-21 0c-2,0 -3,2 -3,4 0,1 1,3 3,3l21 0c1,0 3,-2 3,-3 0,-2 -2,-4 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M119 129l-7 0c-2,0 -4,1 -4,3 0,2 2,3 4,3l7 0c1,0 3,-1 3,-3 0,-2 -2,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M85 135l6 0c2,0 4,-1 4,-3 0,-2 -2,-3 -4,-3l-6 0c-2,0 -4,1 -4,3 0,2 2,3 4,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M85 122l3 0c2,0 3,-2 3,-3 0,-2 -1,-4 -3,-4l-3 0c-2,0 -4,2 -4,4 0,1 2,3 4,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M104 134c1,0 1,-1 1,-2 0,-1 0,-2 -1,-2 -1,-2 -4,-2 -5,0 0,0 -1,1 -1,2 0,1 1,2 1,2 1,1 2,1 3,1 0,0 1,0 2,-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 102,
    cy: 10,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 91,
    cy: 20,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 91,
    cy: 41,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 102,
    cy: 30,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 112,
    cy: 20,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 112,
    cy: 41,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 102,
    cy: 51,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 102,
    cy: 71,
    r: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/Warehouse.959e6f373e0c64f69f251495e5e0aca4.svg";
export { ForwardRef as ReactComponent };